import React, { useState } from "react";
import styled from "styled-components";
import { Tooltip } from "@material-ui/core";
import RadioGroup from "sushiweb/RadioGroup";
import Input from "sushiweb/InputTypes/Input";
import moment from "moment";
import Modal from "sushiweb/Modal";
import {
  BorderedBox,
  FlexContainer,
  Divider,
  FieldsSection,
} from "../../constants/assets/containers";
import QcDriverBasicDetailFields from "../../constants/QcDetails/QcBasicDetailFields.json";
import QcDocumentDetailFields from "../../constants/QcDetails/QcDocumentDetailFields.json";
import {
  capitalizeFirstLetter,
  getPath,
  isMobile,
  isValNull,
} from "../../utils";
import variables from "../../constants/assets/variables";
import CheckBoxDropDown from "../Common/CheckBoxDropDown";
import AddEdit from "sushiweb/Icons/all/AddEdit";
import CheckCircleFill from "sushiweb/Icons/all/CheckCircleFill";
import CrossCircleFill from "sushiweb/Icons/all/CrossCircleFill";
import { DocImg, QcFieldsContainer } from "../../views/QcDetails/backup";
import DriverDocumentModal from "../Common/DriverDocumentModal";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { setQcDetails, updateQcField } from "../../store/actions/QcDetails";
import { getState, getStateList } from "../../store/actions/State";
import InfiniteScrollDropdown from "../Common/InfiniteScrollDropdown";
import QcImpersonation from "./QcImpersonation";
import QcDeviceId from "./QcDeviceId";

const QcDriverBasicDetailsEdit = ({
  onboardingFlow,
  details = {},
  initialState = {},
  handleSave,
  editableField,
  rejectionReasons,
  verifiedOptions,
  setEditableField,
  showSingleFieldEditOptions,
  setShowSingleFieldEditOptions,
  setInitialState,
  updateQcField,
  setQcDetails,
  currentActiveFeId,
  handleVerifiedChange,
  handleRejectionReasonChange,
  qcApproved,
  permission,
  allMenuActions,
  nextPageState,
  getStateList,
  getState,
}) => {
  const [modalContent, setModalContent] = useState("");
  const [showModal, setShowModal] = useState("");
  const [activeImageItemKey, setActiveImageItemKey] = useState({});

  const handleClose = () => {
    setShowModal(false);
  };

  const handleDocClick = (file, key) => {
    setModalContent(file);
    setShowModal(true);
    setActiveImageItemKey(key);
  };

  const Slide = ({ docData }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleItemClick = () => {
      setIsModalOpen(true);
    };

    const handleModalClose = () => {
      setIsModalOpen(false);
    };

    const heading = "Document submitted";
    const doc_url = docData.src;

    return (
      <div>
        <FlexContainer>
          <DocImg
            src={doc_url}
            cursor="pointer"
            alt="Document Image"
            onClick={handleItemClick}
          />

          <Modal
            className={"full-height-modal"}
            visible={isModalOpen}
            onClose={handleModalClose}
            showCloseIcon={true}
            slideOnMobile
            isCentered
            padding="2rem"
            preventFocus
            title={heading}
          >
            <img
              src={doc_url}
              alt="Document Image"
              style={{ width: 500, height: 500 }}
            />
          </Modal>
        </FlexContainer>
      </div>
    );
  };

  const getFieldOptions = (item) => {
    if (item.key === "gender") {
      return ["M", "F"];
    }
  };

  const handleEditSingleField = (item) => {
    setEditableField(item.key);
    setShowSingleFieldEditOptions(item.key);
  };

  const handleCrossClick = (item) => {
    setEditableField("");
    setShowSingleFieldEditOptions("");
    const values = JSON.parse(JSON.stringify(initialState));
    const currVal = getPath(details, item.valuePath, "");
    if (values["basic_details"][item.key]) {
      values["basic_details"][item.key][item.valueKey] = currVal[item.valueKey];
      if (item.secondaryKey) {
        values["basic_details"][item.key][item.secondaryKey] =
          currVal[item.secondaryKey];
      }
      if (item.additionalAssociatedField) {
        values["basic_details"][item.key]["city"] = currVal["city"];
        values["basic_details"][item.key]["state_id"] = currVal["state_id"];
        values["basic_details"][item.key]["state"] = currVal["state"];
      }
    }
    setInitialState(values);
  };

  const handleSaveSingleField = (item) => {
    if (!getPath(details, item.valuePath, "")) {
      return;
    }
    let shouldUpdate = false;
    let secondaryValDiff = false;
    const currValDiff =
      getPath(details, item.valuePath, "")[item.valueKey] !==
      getPath(initialState, item.valuePath, "")[item.valueKey];
    if (currValDiff) {
      shouldUpdate = true;
    }
    if (item.secondaryKey) {
      secondaryValDiff = true;
      if (secondaryValDiff) {
        shouldUpdate = true;
      }
    }

    if (
      item.secondaryKey &&
      isValNull(getPath(initialState, item.valuePath, "")[item.secondaryKey])
    ) {
      return;
    }

    if (
      item.additionalAssociatedField &&
      (isValNull(getPath(initialState, item.valuePath, "")["city"]) ||
        isValNull(getPath(initialState, item.valuePath, "")["state_id"]))
    ) {
      return;
    }

    if (isValNull(getPath(initialState, item.valuePath, "")[item.valueKey])) {
      return;
    }

    if (shouldUpdate) {
      const payload = {
        basic_details: {
          [item.key]: {
            id: getPath(initialState, item.valuePath, "")["id"],
            value: getPath(initialState, item.valuePath, "")[item.valueKey],
          },
        },
      };
      if (secondaryValDiff) {
        payload.basic_details[item.key][item.secondaryKey] =
          item.secondaryKeyInt
            ? Number(
                getPath(initialState, item.valuePath, "")[item.secondaryKey]
              )
            : getPath(initialState, item.valuePath, "")[item.secondaryKey];
      }
      if (item.additionalAssociatedField) {
        payload.basic_details[item.key]["city"] = getPath(
          initialState,
          item.valuePath,
          ""
        )["city"];
        payload.basic_details[item.key]["state_id"] = getPath(
          initialState,
          item.valuePath,
          ""
        )["state_id"];
        payload.basic_details[item.key]["state"] = getPath(
          initialState,
          item.valuePath,
          ""
        )["state"];
      }
      updateQcField(currentActiveFeId, payload).then((res) => {
        if (res) {
          const newDetails = JSON.parse(JSON.stringify(details));
          newDetails["basic_details"][item.key][item.valueKey] =
            payload["basic_details"][item.key][item.valueKey];
          if (secondaryValDiff) {
            newDetails["basic_details"][item.key][item.secondaryKey] =
              payload["basic_details"][item.key][item.secondaryKey];
          }
          if (item.additionalAssociatedField) {
            newDetails["basic_details"][item.key]["city"] = getPath(
              payload,
              item.valuePath,
              ""
            )["city"];
            newDetails["basic_details"][item.key]["state_id"] = getPath(
              payload,
              item.valuePath,
              ""
            )["state_id"];
            newDetails["basic_details"][item.key]["state"] = getPath(
              payload,
              item.valuePath,
              ""
            )["state"];
          }
          setQcDetails(newDetails);
          setEditableField("");
          setShowSingleFieldEditOptions("");
        }
      });
    }
  };

  const handleChange = (item, val, keyToUse, isInteger) => {
    const values = JSON.parse(JSON.stringify(initialState));
    if (values["basic_details"][item.key]) {
      values["basic_details"][item.key][keyToUse || item.valueKey] =
        isInteger && val ? Number(val) : val;
    }
    setInitialState(values);
  };

  const handleGenderChange = (key, val, params) => {
    const item = params[0];
    const values = JSON.parse(JSON.stringify(initialState));
    if (values["basic_details"][item.key]) {
      values["basic_details"][item.key][item.valueKey] = val;
    }
    setInitialState(values);
  };

  const handleDateChange = (item, key, value) => {
    const values = JSON.parse(JSON.stringify(initialState));
    value = moment.utc(value.toLocaleString()).format("YYYY-MM-DD");
    values["basic_details"][item.key][item.valueKey] = value;
    setInitialState(values);
  };
  const getRequiredFlag = (field) => {
    return getPath(details, field.valuePath, "")["required"];
  };

  const getField = (item) => {
    switch (item.type) {
      case "name":
        let aadharDetails = getPath(
          initialState,
          "document_details.aadhar_card_doc",
          ""
        );
        let panDetails = getPath(
          initialState,
          "document_details.pan_card_doc",
          ""
        );
        if (onboardingFlow === "FASTRACK") {
          let panName = getPath(panDetails, "name", "");
          let aAdharName = getPath(aadharDetails, "name", "");

          if (panName && aAdharName) {
            return (
              <FlexContainer justify="space-between">
                <Input
                  id="sushi-input"
                  disabled
                  label="Aadhar name"
                  value={aAdharName}
                  fullWidth={true}
                />
                <Input
                  id="sushi-input"
                  disabled
                  label="PAN name"
                  value={panName}
                  fullWidth={true}
                />
              </FlexContainer>
            );
          }
        } else {
          let panDoc = getPath(panDetails, "url", "");
          let permanentAddressDoc = getPath(
            initialState,
            "document_details.address_doc.url"
          );
          return (
            <FlexContainer justify="space-between">
              <div>
                <p className="section-heading">Pan</p>
                <DocImg
                  onClick={() => handleDocClick(panDoc, item.key)}
                  src={panDoc}
                  cursor="pointer"
                  alt=""
                />
              </div>
              <div>
                <p className="section-heading">Permanent address doc</p>
                <DocImg
                  onClick={() => handleDocClick(permanentAddressDoc, item.key)}
                  src={permanentAddressDoc}
                  cursor="pointer"
                  alt=""
                />
              </div>
            </FlexContainer>
          );
        }
      case "text":
        return (
          <Input
            id="sushi-input"
            data-testId={"Qc-" + item.key}
            disabled={editableField !== item.key}
            label={item.label}
            fullWidth
            onChange={(e) => handleChange(item, e)}
            value={getPath(initialState, item.valuePath, "")[item.valueKey]}
          />
        );
      case "photo":
        let photo = {};
        let label = "";
        let doc = "";
        if (details.onboarding_flow == "FASTRACK") {
          photo = QcDocumentDetailFields["aadhar_card_doc"];
          doc = "aadhar_card_doc";
          label = "Aadhar Photo";
        } else {
          photo = QcDocumentDetailFields["pan_card_doc"];
          doc = "pan_card_doc";
          label = "PAN Card Photo";
        }
        let docData =
          initialState.basic_details.driver_photo.all_submitted_doc_urls;
        return (
          <div>
            <div>
              <FlexContainer align="flex-start">
                <div text-align="center">
                  <p className="section-heading">Profile Photo</p>
                  <DocImg
                    width={500}
                    height={500}
                    onClick={() =>
                      handleDocClick(
                        getPath(initialState, item.valuePath, "")[
                          item.valueKey
                        ],
                        item.key
                      )
                    }
                    src={
                      getPath(initialState, item.valuePath, "")[item.valueKey]
                    }
                    cursor="pointer"
                    alt=""
                  />
                </div>
                {getPath(initialState, photo.valuePath, "")[photo.urlKey] && (
                  <>
                    <Divider
                      height="250px"
                      width="5px"
                      color={variables.grey}
                    />
                    <div text-align="center">
                      <p className="section-heading">{label}</p>
                      <DocImg
                        src={
                          getPath(initialState, photo.valuePath, "")[
                            photo.urlKey
                          ]
                        }
                        onClick={() =>
                          handleDocClick(
                            getPath(initialState, item.valuePath, "")[
                              item.valueKey
                            ],
                            doc
                          )
                        }
                        cursor="pointer"
                        alt=""
                      />
                    </div>
                  </>
                )}
              </FlexContainer>
            </div>
            <div>
              <FlexContainer>
                {docData != null && docData.length > 0 && (
                  <div
                    style={{
                      float: "left",
                      marginBottom: "10px",
                    }}
                  >
                    <Divider
                      height="5px"
                      width="1000px"
                      color={variables.grey}
                    />
                    <p
                      className="section-heading"
                      style={{
                        textAlign: "left",
                        padding: "25px",
                        marginBottom: "10px",
                        textDecoration: "underline",
                      }}
                    >
                      All submitted documents
                    </p>
                    <DocImgContainer>
                      {docData.map((doc) => {
                        return <Slide docData={doc} key={doc.id} />;
                      })}
                    </DocImgContainer>
                  </div>
                )}
              </FlexContainer>
            </div>
          </div>
        );
      case "calender":
        return (
          <Input
            id="sushi-input"
            className="calender-input"
            fullWidth={true}
            disabled={editableField !== item.key}
            value={moment(
              getPath(initialState, item.valuePath, "")[item.valueKey]
            ).format("YYYY-MM-DD")}
            type="date"
            onChange={(val) => handleDateChange(item, item.key, val)}
          />
        );

      case "dropdown":
        return (
          <CheckBoxDropDown
            options={getFieldOptions(item)}
            disabled={editableField !== item.key}
            value={getPath(initialState, item.valuePath, "")[item.valueKey]}
            handleChange={handleGenderChange}
            labelWidth="25%"
            placeholder={item.label}
            keyToChange={item.key}
            showCross={true}
            extraParams={[item]}
            className="inbox-dropdown"
            id={`driverQcBasicDetailsDropdown${item.key}`}
          />
        );
      case "impersonation_component":
        if (
          !isValNull(initialState.basic_details.impersonation) &&
          initialState.basic_details.impersonation.auto_verify
        ) {
          return <></>;
        }

        var faceMatch = initialState.basic_details.face_match_data.match_data;
        var phoneMatch = initialState.basic_details.phone_match_data.match_data;

        var deviceMatch =
          initialState.basic_details.device_match_data.match_data;
        var riderCity = "";
        if (
          !isValNull(initialState.basic_details.city) &&
          initialState.basic_details.city.length != 0
        ) {
          riderCity = initialState.basic_details.city;
        }

        return (
          <QcImpersonation
            faceMatch={faceMatch}
            phoneMatch={phoneMatch}
            deviceMatch={deviceMatch}
            handleSave={handleSave}
            riderDataToShow={[
              {
                city: riderCity,
                profile_pic_url: initialState.basic_details.driver_photo.url,
                fe_id: currentActiveFeId,
              },
            ]}
            setQcDetails={setQcDetails}
            initialState={initialState}
            currentActiveFeId={currentActiveFeId}
            updateQcField={updateQcField}
            setInitialState={setInitialState}
            qcDetails={details}
            handleVerifiedChange={handleVerifiedChange}
            item={item}
            handleRejectionReasonChange={handleRejectionReasonChange}
          />
        );
      case "device_linkages_component":
        if (
          !isValNull(initialState.basic_details.device_linkages) &&
          initialState.basic_details.device_linkages.auto_verify
        ) {
          return <></>;
        }

        var faceMatch =
          initialState.basic_details.device_linkages.device_linkage_data;
        var phoneMatch = initialState.basic_details.phone_match_data.match_data;

        var deviceMatch =
          initialState.basic_details.device_match_data.match_data;
        var riderCity = "";
        if (
          !isValNull(initialState.basic_details.city) &&
          initialState.basic_details.city.length != 0
        ) {
          riderCity = initialState.basic_details.city;
        }

        return (
          <QcDeviceId
            faceMatch={faceMatch}
            phoneMatch={phoneMatch}
            deviceMatch={deviceMatch}
            handleSave={handleSave}
            riderDataToShow={[
              {
                city: riderCity,
                profile_pic_url: initialState.basic_details.driver_photo.url,
                fe_id: currentActiveFeId,
              },
            ]}
            setQcDetails={setQcDetails}
            initialState={initialState}
            currentActiveFeId={currentActiveFeId}
            updateQcField={updateQcField}
            setInitialState={setInitialState}
            qcDetails={details}
            handleVerifiedChange={handleVerifiedChange}
            item={item}
            handleRejectionReasonChange={handleRejectionReasonChange}
          />
        );
      default:
        return "";
    }
  };

  const getSecondaryField = (item) => {
    if (item.secondaryKey === "zip_code") {
      return (
        <Input
          id="sushi-input"
          data-testId={"Qc-zip_code_" + item.key}
          disabled={editableField !== item.key}
          label={item.secondaryKeyLabel}
          fullWidth
          onChange={(e) =>
            handleChange(item, e, item.secondaryKey, item.secondaryKeyInt)
          }
          value={
            getPath(initialState, item.valuePath, "")[item.secondaryKey] || ""
          }
        />
      );
    }
  };

  const handleStateChange = (key, val, extraParams, stateObj) => {
    const stateName = getPath(stateObj, "name", "");
    const values = JSON.parse(JSON.stringify(initialState));
    if (values["basic_details"]["permanent_address"]) {
      values["basic_details"]["permanent_address"]["state_id"] = Number(val);
      values["basic_details"]["permanent_address"]["state"] = stateName;
    }
    setInitialState(values);
  };

  const handleCurrentAddressChangeChange = (
    key,
    val,
    extraParams,
    stateObj
  ) => {
    const stateName = getPath(stateObj, "name", "");
    const values = JSON.parse(JSON.stringify(initialState));
    if (values["basic_details"]["current_address"]) {
      values["basic_details"]["current_address"]["state_id"] = Number(val);
      values["basic_details"]["current_address"]["state"] = stateName;
    }
    setInitialState(values);
  };

  const getAdditionalAssociatedFields = (item) => {
    return (
      <>
        <Input
          id="sushi-input"
          data-testid={"Qc-city_" + item.key}
          disabled={editableField !== item.key}
          label="City/District"
          fullWidth
          onChange={(e) => handleChange(item, e, "city")}
          value={getPath(initialState, item.valuePath, "")["city"] || ""}
        />
        <InfiniteScrollDropdown
          id="qcRiderStateDropdown"
          priorityFlag
          getActiveList={getStateList}
          nextPage={nextPageState}
          resKey="states"
          modalState="Edit"
          keyName="state_id"
          labelKey="name"
          getDataLabelKey="state.name"
          keyTypeToSet="id"
          disabled={editableField !== item.key}
          label="State"
          handleChange={
            item.key === "current_address"
              ? handleCurrentAddressChangeChange
              : handleStateChange
          }
          remoteSearchApplicable
          // activeFilters={activeFilters}
          activeElement={{
            state_id: getPath(initialState, item.valuePath, "")["state_id"],
          }}
          getActiveItemById={getState}
          appliedFilters={{}}
          notShowCross={true}
          remoteSearchKey="startswith"
        />
      </>
    );
  };

  const getAssociatedPhoto = (item) => {
    if (item.key === "permanent_address") {
      const associatedDoc =
        getPath(initialState, "document_details.address_doc", "") ||
        getPath(initialState, "document_details.license_card_doc", "");
      return associatedDoc ? (
        <DocImg
          onClick={() =>
            handleDocClick(getPath(associatedDoc, "url", ""), item.key)
          }
          src={getPath(associatedDoc, "url", "")}
          alt=""
        />
      ) : (
        ""
      );
    }
  };

  const getRejectionReasons = (key) => {
    if (getPath(Object.keys(rejectionReasons), "length", "")) {
      return rejectionReasons
        .filter((reason) => reason.key === key)
        .map((obj) => obj.reason);
    }
    return [];
  };

  const getModalValue = () => {
    if (activeImageItemKey === "permanent_address") {
      return (
        getPath(details, "basic_details.permanent_address.value", "") +
        "," +
        getPath(details, "basic_details.permanent_address.zip_code", "")
      );
    }
    return false;
  };

  const TickIcon = React.forwardRef(function TickIcon(props, ref) {
    //  Spread the props to the underlying DOM element.
    return (
      <div {...props} ref={ref} className="mr-10">
        <CheckCircleFill
          color={variables.primaryColor}
          className="cursor-pointer saveIcon"
          onClick={() =>
            handleSaveSingleField(QcDriverBasicDetailFields[props.field])
          }
        />
      </div>
    );
  });

  const CrossIcon = React.forwardRef(function CrossIcon(props, ref) {
    //  Spread the props to the underlying DOM element.
    return (
      <div {...props} ref={ref}>
        <CrossCircleFill
          onClick={() =>
            handleCrossClick(QcDriverBasicDetailFields[props.field])
          }
          color={variables.primaryColor}
          className="cursor-pointer"
        />
      </div>
    );
  });

  const isEditable = (field) => {
    return getPath(initialState, "basic_details." + field + ".editable", true);
  };

  const showField = (field) => {
    if (field === "impersonation") {
      return getPath(initialState, "basic_details.impersonation.display", true);
    }
    if (field === "device_linkages") {
      return getPath(
        initialState,
        "basic_details.device_linkages.display",
        true
      );
    }
    return true;
  };

  const getVerifiedValue = (key) => {
    var localVerifiedOptions = JSON.parse(JSON.stringify(verifiedOptions));
    if (key == "impersonation") {
      localVerifiedOptions[1]["disabled"] = true;
    } else if (!isEditable(key)) {
      localVerifiedOptions[1]["disabled"] = true;
      localVerifiedOptions[0]["disabled"] = true;
    }
    return localVerifiedOptions;
  };
  return [
    <QcDriverBasicDetailsEditContainer>
      {getPath(Object.keys(initialState), "length", 0) > 0 &&
        Object.keys(initialState.basic_details).map((field, index) => {
          return (
            QcDriverBasicDetailFields[field] &&
            showField(field) &&
            getRequiredFlag(QcDriverBasicDetailFields[field]) && (
              <FieldsSection key={field}>
                <p className="section-heading">
                  {QcDriverBasicDetailFields[field].heading.toUpperCase()}
                </p>
                <BorderedBox
                  className="fields-holder mb-40"
                  maxWidth={
                    field == "impersonation" || field == "device_linkages"
                      ? "100% !important"
                      : "80%"
                  }
                >
                  <QcFieldsContainer
                    style={
                      isMobile() ||
                      field == "impersonation" ||
                      field == "device_linkages"
                        ? { maxWidth: "100% !important" }
                        : { maxWidth: "60%" }
                    }
                  >
                    <FlexContainer justify="flex-start" align="flex-start">
                      <div
                        className={`w-full ${
                          !QcDriverBasicDetailFields[field]["noRightMargin"] &&
                          "mr-10"
                        }`}
                      >
                        {getField(QcDriverBasicDetailFields[field])}
                        {QcDriverBasicDetailFields[field]
                          .additionalAssociatedField &&
                          getAdditionalAssociatedFields(
                            QcDriverBasicDetailFields[field]
                          )}
                        {QcDriverBasicDetailFields[field].hasSecondaryField &&
                          getSecondaryField(QcDriverBasicDetailFields[field])}
                      </div>
                      {QcDriverBasicDetailFields[field].isEditable &&
                        isEditable(field) &&
                        !qcApproved &&
                        allMenuActions[permission] &&
                        (editableField === field &&
                        showSingleFieldEditOptions === field ? (
                          <FlexContainer justify="flex-start">
                            <Tooltip title="Save" arrow placement="top">
                              <TickIcon field={field} />
                            </Tooltip>
                            <Tooltip title="Cancel" arrow placement="top">
                              <CrossIcon field={field} />
                            </Tooltip>
                          </FlexContainer>
                        ) : (
                          !showSingleFieldEditOptions && (
                            <AddEdit
                              className="cursor-pointer editIcon"
                              onClick={() =>
                                handleEditSingleField(
                                  QcDriverBasicDetailFields[field]
                                )
                              }
                              color={variables.primaryColor}
                            />
                          )
                        ))}
                    </FlexContainer>
                    {QcDriverBasicDetailFields[field].photoAssociated &&
                      getAssociatedPhoto(QcDriverBasicDetailFields[field])}
                    {QcDriverBasicDetailFields[field].verify ? (
                      <RadioGroup
                        options={getVerifiedValue(field)}
                        horizontal
                        selectedColor={variables.primaryColor}
                        selected={
                          getPath(
                            initialState,
                            QcDriverBasicDetailFields[field].valuePath,
                            ""
                          )["verified"]
                        }
                        className="sushi-radios"
                        onChange={(e) =>
                          handleVerifiedChange(
                            QcDriverBasicDetailFields[field],
                            e,
                            "basic_details"
                          )
                        }
                        name={`${field}-verified-options`}
                      />
                    ) : (
                      ""
                    )}
                    {QcDriverBasicDetailFields[field].verify ? (
                      <CheckBoxDropDown
                        options={getRejectionReasons(field)}
                        value={
                          getPath(
                            initialState,
                            QcDriverBasicDetailFields[field].valuePath,
                            ""
                          ).rejection_reason
                        }
                        disabled={
                          qcApproved ||
                          getPath(
                            initialState,
                            `basic_details.${field}.verified`,
                            false
                          ) ||
                          ((field == "impersonation" ||
                            field == "device_linkages") &&
                            getPath(
                              initialState,
                              `basic_details.${field}.verified`,
                              false
                            ) == false)
                        }
                        handleChange={handleRejectionReasonChange}
                        placeholder="Select rejection reason"
                        keyToChange={field}
                        extraParams={[
                          QcDriverBasicDetailFields[field],
                          "basic_details",
                        ]}
                        showCross={true}
                        labelWidth={isMobile() ? "50%" : "30%"}
                        id={`driverQcBasicDetailsDropdown${field}`}
                      />
                    ) : (
                      ""
                    )}
                  </QcFieldsContainer>
                </BorderedBox>
              </FieldsSection>
            )
          );
        })}
    </QcDriverBasicDetailsEditContainer>,
    activeImageItemKey == "aadhar_card_doc" ||
    activeImageItemKey == "pan_card_doc" ? (
      <Modal
        visible={showModal}
        onClose={handleClose}
        type="medium"
        showCloseIcon={true}
        slideOnMobile
        isCentered
        padding="2rem"
        preventFocus
      >
        <div>
          <FlexContainer align="flex-start">
            <div>
              <p className="section-heading">Profile Photo</p>
              <img
                width={500}
                height={500}
                src={getPath(initialState, "basic_details.driver_photo.url")}
                cursor=""
                alt=""
              />
            </div>
            <Divider height="auto" width="15px" color={variables.black} />
            <div text-align="center">
              <p className="section-heading">
                {activeImageItemKey == "aadhar_card_doc"
                  ? "Aadhar Photo"
                  : "PAN Photo"}
              </p>
              <img
                width={500}
                height={500}
                src={getPath(
                  initialState,
                  "document_details." + activeImageItemKey + ".url",
                  ""
                )}
                cursor=""
                alt=""
              />
            </div>
          </FlexContainer>
        </div>
      </Modal>
    ) : (
      <DriverDocumentModal
        fullWidthModal={activeImageItemKey !== "driver_photo"}
        optionalPhotoTitle="Driver Photo"
        optionalPhotoUrl={
          activeImageItemKey !== "driver_photo"
            ? getPath(initialState, "basic_details.driver_photo.url", "")
            : undefined
        }
        optionalInput={
          Object.keys(activeImageItemKey).length > 0 &&
          getModalValue() && (
            <Input
              id="sushi-input"
              data-testId="modalInputVal"
              disabled={true}
              label={capitalizeFirstLetter(
                activeImageItemKey.split("_").join(" ") + " value"
              )}
              value={getModalValue()}
            />
          )
        }
        showModal={showModal}
        handleClose={handleClose}
        modalContent={modalContent}
      />
    ),
  ];
};

const QcDriverBasicDetailsEditContainer = styled(BorderedBox)`
  .MuiAutocomplete-root {
    padding-right: unset;
  }
`;

export const DocImgContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
`;

function mapStateToProps(state) {
  const { QcDetails, MenuActions, State } = state;
  return {
    currentActiveFeId: QcDetails.currentActiveFeId,
    allMenuActions: MenuActions.allMenuActions,
    nextPageState: State.nextPage,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateQcField: bindActionCreators(updateQcField, dispatch),
    setQcDetails: bindActionCreators(setQcDetails, dispatch),
    getStateList: bindActionCreators(getStateList, dispatch),
    getState: bindActionCreators(getState, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QcDriverBasicDetailsEdit);
